export interface Caderno {
  id: string;
  title: string;
  subtitle?: string;
  authors: string[];
  year: number;
  coverImage: string;
  pdfFile: string;
  description?: string;
}

export const cadernos: Caderno[] = [
  {
    id: "antotipia",
    title: "Antotipia",
    subtitle: "Impressões Fotográficas com Pigmentos Naturais", // Add subtitle here if needed
    authors: ["Silvia Lorenz-Martins"],
    year: 2025,
    coverImage: "/Cadernos/Antotipia/img_capa.png",
    pdfFile: "/Cadernos/Antotipia/Antotipia.pdf",
    description: "",
  },
  {
    id: "colorir",
    title: "Aves da UFRJ - Livro para Colorir",
    subtitle: "",
    authors: ["Silvia Lorenz-Martins"],
    year: 2025,
    coverImage: "/Cadernos/Livro Colorir/img_capa.png",
    pdfFile: "/Cadernos/Livro Colorir/Livro de colorir.pdf",
    description: "",
  },
  {
    id: "artbook",
    title: "Aves do Fundão",
    subtitle: "Entre a arte, técnica e percepcão visual", // Add subtitle here if needed
    authors: [
      "Silvia Lorenz-Martins",
      "Ary Moraes",
      "Cassia Curan Turci",
      "Graça Lima",
      "Jeanine Geammal",
    ],
    year: 2024,
    coverImage: "/Cadernos/ArtBook/img_capa.png",
    pdfFile: "/Cadernos/ArtBook/Art Book 21 11.pdf",
    description: "",
  },
  {
    id: "cianotipo",
    title: "Oficina de Cianotipia",
    subtitle: "e o ensino de ciências", // Add subtitle here if needed
    authors: ["Silvia Lorenz-Martins"],
    year: 2022,
    coverImage: "/Cadernos/Cianotipo/img_capa.png",
    pdfFile: "/Cadernos/Cianotipo/Oficina_Cianotipo_acadêmica_V_final-2.pdf",
    description: "",
  },
  {
    id: "guia-aves",
    title: "As aves do Valongo",
    subtitle: "visitantes e moradores", // Add subtitle here if needed
    authors: ["Silvia Lorenz-Martins", "Daniel Mello"],
    year: 2022,
    coverImage: "/Cadernos/GuiaAves/img_capa.png",
    pdfFile:
      "/Cadernos/GuiaAves/CÁTALOGO AVES DO VALONG_pdf celular_2022.12.01.pdf",
    description: "",
  },
];
